import { render } from "./subMenuPagar.vue?vue&type=template&id=be381ffe"
import script from "./subMenuPagar.vue?vue&type=script&lang=js"
export * from "./subMenuPagar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__